import React from 'react'
import { Link } from 'react-router-dom'
import ReliefLogo from '../ReliefLogo.png'
import Button from '@mui/material/Button';
import ModalSignUp from '../components/ModalSignUp'

export default function Navbar() {
  return (
    <div style={{display : 'flex' , justifyContent : 'space-around'}}  >
        
<img src={ReliefLogo} alt="" style={{height : '150px' , width : '220px' , marginRight : '1100px'}} />

<ModalSignUp/>

{/* <Link to="/media" >
<h4>Media</h4>
</Link> */}

    </div>
  )
}
